module.exports = __webpack_public_path__ + "img/Sutrimo.15c62746.png";